<template>
    <FormModal :model="model" :init="init" modal-id="store" :onSetIsEditMode="onSetIsEditMode">
        <template>
            <div :key="key" class="d-flex">
                <ItemBadges :model="model" class="mb-1" />
            </div>
        </template>
        <template v-slot:form="{ error: error }">
<!--
            <GridPage
                :form-default="{
                }"
                :filters-default="{
                    provider: 'amazon',
                }"
                :filter-items="[
                ]"
                filters-q-placeholder="名前"
                form-modal-id="item"
                search-action="item/index"
                >
                <template v-slot:form="{ form, init }">
                    <Item :model="form" :init="init"></Item>
                </template>

                <template v-slot:column="{ item }">
                {{ item }}
                </template>
            </GridPage>
-->
{{ model }}
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import FormModal from '@/components/FormModal.vue'
import Item from '@/components/Item.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ShareButtons from '@/components/ShareButtons.vue'
import InputError from '@/components/InputError.vue'
import blueimpLoadImage from 'blueimp-load-image'

export default {
    components: {
        GridPage,
        FormModal,
        Item,
        ItemBadges,
        ShareButtons,
        InputError,
    },
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return null
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'trans',
        ])
    },
    mounted() {},
    methods: {
        onSetIsEditMode (model) {
            if (model.is_edit_mode) {
                if (model.images.length) {
                    setTimeout(() => {
                        this.fixImage(model.images[0])
                    }, 1000)
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
</style>


